import IDataNotFound from "../../../../shared/interfaces/data-not-found.interface";

export const DATA_NOT_FOUND: IDataNotFound = {
    title: "Perfecto!",
    description: "¡Has tomado todas las asistencias de este mes!"
};